<div class="
    absolute
    h-full w-full
    bg-slate-500
    flex flex-col
    justify-center gap-10
    ">

    <div class="
        h-60 w-10/12 sm:w-80
        mx-auto
        bg-slate-400
        flex flex-col
        rounded-lg
        shadow-xl
        shadow-slate-600
        text-white text-2xl
        ">

        <div class="
            mx-auto my-auto
            bg-red-500/0
            text-center
            ">

            <div class="
                flex flex-col
                bg-pink-500/0
                mb-5
                ">
                <span class="
                    text-sm
                    italic
                    underline
                    text-white/70
                    ">
                    ~TailwindCSS test
                </span>
            </div>

            <div class="
                flex flex-col
                bg-pink-500/0
                text-xl
                ">
                <span>
                    TailwindCSS is
                </span>
                <br>
                <span style="background-color: black;" class="font-bold text-green-500">
                    working, if you can read this!
                </span>
                <br>
                <span class="text-slate-400">
                    not working, if you can read this :(
                </span>
            </div>

        </div>

    </div>

    <div class="
        h-60 w-10/12 sm:w-80
        mx-auto
        bg-slate-400
        flex flex-col
        rounded-lg
        shadow-xl
        shadow-slate-600
        text-white text-2xl
        ">

        <div class="
            mx-auto my-auto
            bg-red-500/0
            text-center
            ">

            <div class="
                flex flex-col
                bg-pink-500/0
                mb-5
                ">
                <span class="
                    text-sm
                    italic
                    underline
                    text-white/70
                    ">
                    ~3js test
                </span>
            </div>



        </div>

        <div class="
            flex flex-col
            bg-pink-500
            h-full w-full
            ">
            <threejs-base-scene class="
                h-full w-full
                "></threejs-base-scene>
        </div>

    </div>

</div>


<app-nav-bar></app-nav-bar>

<app-version-panel></app-version-panel>
